<ng-container *ngIf="(isFromHomeScreen)|| (isInteracticeCardsAvailable) || isMemoryCardsAvailable">
<div class="SLV2-ads-area m-hide">
<div class="SLV2-ads-wrap fixed">

<!-- card of the day ad start -->
<app-memory-banner-card class="small SLV2-slider-ad-box" *ngIf="isFromHomeScreen"></app-memory-banner-card>
<!-- card of the day ad ended -->

<!-- slider ad box start -->
<!-- <div class="SLV2-slider-ad-box">
    <ngb-carousel #carousel class="singleCarousel ads-single-slider" [interval]="5000" [pauseOnHover]="pauseOnHover"
        [pauseOnFocus]="pauseOnFocus">
        <ng-template ngbSlide>
            <div class="SLV2-ad-slide slide-1">
                <div class="SLV2-ad-content">
                    <h4 class="SLV2-ad-slide-text">
                        Stuck on a problem?<br>
                        <small>Ask your doubt here.</small>
                    </h4>
                    <div class="SLV2-upload-box">
                        <img src="selflearnv2-ui/assets/img/self-learn-v2/camera-blue-icon.svg" />
                        <span>Upload a doubt</span>
                    </div>
                </div>
                <img src="selflearnv2-ui/assets/img/self-learn-v2/question-mark-rounded.svg" class="bg-icon" />
            </div>
        </ng-template>
        <ng-template ngbSlide>
            <div class="SLV2-ad-slide slide-2">
                <div class="SLV2-ad-content">
                    <h4 class="SLV2-ad-slide-text">
                    Invite your friends <br>and earn rewards
                    </h4>
                    <button class="ads-blue-button">Explore Now</button>
                </div>
                <img src="selflearnv2-ui/assets/img/self-learn-v2/ads-bg-2.svg" class="bg-icon" />
            </div>
        </ng-template>
    </ngb-carousel>
</div> -->
<!-- slider ad box ended -->


<!-- set goal box start -->
<!-- <div class="SLV2-setgoal-ad-box">
    <img src="selflearnv2-ui/assets/img/self-learn-v2/target-icon.svg" class="SLV2-setgoal-icon" />
    <div class="SLV2-setgoal-content">
        <h4 class="SLV2-setgoal-hdng">Hi, Suman<br>Let’s set a weekly goal</h4>
        <h5 class="SLV2-setgoal-text">Choose a weekly goal and set learning reminders to make progress.</h5>
        <button class="ads-blue-button">Set Goal</button>
    </div>
    <img src="selflearnv2-ui/assets/img/self-learn-v2/set-goal-bg-1.png" class="SLV2-setgoal-bg" />
</div> -->
<!-- set goal box ended -->


<!-- set goal box 2 start -->
<!-- <div class="SLV2-setgoal-ad-box golbox-2">
    <div class="SLV2-setgoal-chart-frame">
        <apx-chart [series]="donutchartOptions_ads.series" [chart]="donutchartOptions_ads.chart" [labels]="donutchartOptions_ads.labels" [dataLabels]="donutchartOptions_ads.dataLabels"
            [legend]="donutchartOptions_ads.legend" [responsive]="donutchartOptions_ads.responsive"
            [tooltip]="donutchartOptions_ads.tooltip" [fill]="donutchartOptions_ads.fill" [stroke]="donutchartOptions_ads.stroke"
            [states]="donutchartOptions_ads.states" [plotOptions]="donutchartOptions_ads.plotOptions"
            class="SLV2-setgoal-chart"></apx-chart>
    </div>
    <div class="SLV2-setgoal-content">
        <h4 class="SLV2-setgoal-hdng">My Goals</h4>
        <h5 class="SLV2-setgoal-text">It’s time to complete your <br>goals and sharpen skills</h5>
        <button class="ads-blue-button">View Goals</button>
    </div>
    <img src="selflearnv2-ui/assets/img/self-learn-v2/set-goal-bg-2.png" class="SLV2-setgoal-bg" />
</div> -->
<!-- set goal box 2 ended -->


<!-- text book solution box start -->
<!-- <div class="SLV2-solutnbook-box" *ngIf="!selfLearnService.isFromLearn()">
    <div class="SLV2-solutnbook-cnt">
        <h4 class="SLV2-soltntext-hdng">Text Book Solutions</h4>
        <h5 class="SLV2-soltntext-text"><small>Math book added </small><br>R.D SHARMA</h5>
        <button class="textsolutn-button">Read Now</button>
    </div>
    <img src="selflearnv2-ui/assets/img/self-learn-v2/text-book-big-icon.svg" class="SLV2-solutnbook-icon" />
</div> -->
<!-- text book solution box ended -->


<!-- bookmark ad box start -->
<!-- <div class="SLV2-bookmark-adbox">
    <button class="SLV2-bookmark-arrow-btn">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/right-blue-arrow.svg" />
    </button>
    <div class="SLV2-bookmark-content">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-blue-icon.svg" class="bookmrkicon" />
        <div class="bookmrktext-area">
            <h4 class="bookmrk-hdng"><b>29</b> Bookmarks</h4>
            <h5 class="bookmrk-subhdng">Be sure to check your recent <br>bookmarks.</h5>
        </div>
    </div>
    <img src="selflearnv2-ui/assets/img/self-learn-v2/bookmark-bg-icon.svg" class="SLV2-bookmark-adbox-bg" />
</div> -->
<!-- bookmark ad box ended -->


<!-- parctice ad box 1 open -->
<!-- <div class="SLV2-prctcs-ad-box">
    img class="SLV2-prctcs-ad-title" src="selflearnv2-ui/assets/img/self-learn-v2/practice-test-title.svg" /> 
    <img class="SLV2-prctcs-ad-title" src="selflearnv2-ui/assets/img/self-learn-v2/practice-test-title-2.png" />

    <button class="SLV2-prctcs-ad-lock-text"><img class="lock-icon"
            src="selflearnv2-ui/assets/img/self-learn-v2/lock-red-icon.svg" />Locked</button>
    <button class="SLV2-prctcs-ad-lock-text unlock" *ngIf="false"><img class="lock-icon"
            src="selflearnv2-ui/assets/img/self-learn-v2/lock-green-icon.svg" />Unlocked</button>

    <p class="SLV2-prctcs-ad-text">Achieve 50% of chapter progress to unlock this test</p>

    <button class="SLV2-prctcs-ad-button" *ngIf="false">Attempt now</button>
</div> -->

<!-- parctice ad box 1 closed -->


<!-- parctice ad box 2 open -->
<!-- <div class="SLV2-prctcs-ad-box attemp">
     <img class="SLV2-prctcs-ad-title" src="selflearnv2-ui/assets/img/self-learn-v2/practice-test-title.svg" /> 
    <img class="SLV2-prctcs-ad-title" src="selflearnv2-ui/assets/img/self-learn-v2/practice-test-title-2.png" />

    <button class="SLV2-prctcs-ad-lock-text" *ngIf="false"><img class="lock-icon"
            src="selflearnv2-ui/assets/img/self-learn-v2/lock-red-icon.svg" />Locked</button>
    <button class="SLV2-prctcs-ad-lock-text unlock" *ngIf="false"><img class="lock-icon"
            src="selflearnv2-ui/assets/img/self-learn-v2/lock-green-icon.svg"/>Unlocked</button>

    <p class="SLV2-prctcs-ad-text">Achieve 50% of chapter progress to unlock this test</p>

    <button class="SLV2-prctcs-ad-button">Attempt now</button>
</div> -->
<!-- parctice ad box 2 closed -->


<!-- interactive activity ad box start -->
<div class="SLV2-intractivity-ad-box" *ngIf="!isFromHomeScreen&&isInteracticeCardsAvailable">
    <div class="SLV2-intractivity-content">
        <h4 class="SLV2-intractivity-hdng">Interactive Activities</h4>
        <h5 class="SLV2-intractivity-text">Now, Play and learn <br>at the same time!</h5>
        <button class="ads-intractivity-button" (click)="exloreInteractiveStories()">Explore Now</button>
    </div>
    <img src="selflearnv2-ui/assets/img/self-learn-v2/Interactive-activities-icon.svg" class="SLV2-intractivity-bg" />
</div>
<!-- interactive activity ad box ended -->

<h4 class="SLV2-ad-quick-link-hdng" *ngIf="isMemoryCardsAvailable&&!isFromHomeScreen">Quick Links</h4>


<!-- quick link card start -->
<button class="SLV2-quicklink-card" (click)="navigateTomemorycards()" *ngIf="isMemoryCardsAvailable&&!isFromHomeScreen">
    <div class="SLV2-quicklink-cont" >
        <div class="SLV2-quicklink-card-holder">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card-icon.svg"  class="SLV2-intractivity-bg" />
        </div>
        <span>Memory Card</span>
    </div>
    <button class="SLV2-quicklink-arrow-btn"><img src="selflearnv2-ui/assets/img/self-learn-v2/right-red-arrow.svg" /></button>
</button>
<!-- <button class="SLV2-quicklink-card yellow">
    <div class="SLV2-quicklink-cont">
        <div class="SLV2-quicklink-card-holder">
            <img src="selflearnv2-ui/assets/img/self-learn-v2/Light_Bulb.svg"  class="SLV2-intractivity-bg" />
        </div>
        <span>Formula Sheets</span>
    </div>
    <button class="SLV2-quicklink-arrow-btn"><img src="selflearnv2-ui/assets/img/self-learn-v2/right-red-arrow.svg" /></button>
</button> -->
<!-- quick link card ended -->

</div>
</div>
</ng-container>
